export const PALETTE_KEY = 'Palette';
export const LIGHT_COLOR_TYPE = 'light';
export const DARK_COLOR_TYPE = 'dark';
export const PRIMARY_COLOR_TYPE = 'primary';
export const SECONDARY_COLOR_TYPE = 'secondary';
export const INFO_COLOR_TYPE = 'info';
export const ERROR_COLOR_TYPE = 'error';
export const SUCCESS_COLOR_TYPE = 'success';
export const WARNING_COLOR_TYPE = 'warning';
export const COMMON_COLOR_TYPES_ORDER = [
  LIGHT_COLOR_TYPE,
  DARK_COLOR_TYPE,
  PRIMARY_COLOR_TYPE,
  SECONDARY_COLOR_TYPE,
  ERROR_COLOR_TYPE,
  INFO_COLOR_TYPE,
  SUCCESS_COLOR_TYPE,
  WARNING_COLOR_TYPE,
];
